import { atom } from 'jotai';

export const endTrialModalOpenAtom = atom(false);
export const extendTrialModalOpenAtom = atom(false);
export const endPromotedTrialModalAtom = atom(false);
export const trialEndPlanSelectionModalOpenAtom = atom(false);
